import {
  DROPPED_INTERACTION_EVENT_TYPES,
  ELEMENT_INTERACTION_EVENT_NAME,
  INNERTEXT_MAX_LENGTH,
  PII_MARKERS,
  PII_PATTERNS
} from './consts';
import { redactKnownPii } from './piiRegistry';

export const luhnCheck = (input) => {
  const digits = String(input).replace(/[\s-]/g, '');
  if (digits.length === 0 || !/^\d+$/.test(digits)) return false;

  const sum = digits
    .split('')
    .reverse()
    .reduce((acc, ch, i) => {
      const d = ch.charCodeAt(0) - 48;
      const doubled = i % 2 === 1 ? d * 2 : d;
      return acc + (doubled > 9 ? doubled - 9 : doubled);
    }, 0);

  return sum % 10 === 0;
};

const scrubString = (value) =>
  redactKnownPii(
    value
      .replace(PII_PATTERNS.EMAIL, PII_MARKERS.EMAIL)
      .replace(PII_PATTERNS.CARD_CANDIDATE, (match) => (luhnCheck(match) ? PII_MARKERS.CARD : match))
      .replace(PII_PATTERNS.PHONE_AU, PII_MARKERS.PHONE)
      .replace(PII_PATTERNS.BSB, PII_MARKERS.BSB)
  );

const isPlainObject = (value) => {
  if (value === null || typeof value !== 'object') return false;
  const proto = Object.getPrototypeOf(value);
  return proto === Object.prototype || proto === null;
};

export const scrubPii = (value) => {
  if (typeof value === 'string') return scrubString(value);
  if (Array.isArray(value)) return value.map(scrubPii);
  if (isPlainObject(value)) {
    return Object.fromEntries(Object.entries(value).map(([key, val]) => [key, scrubPii(val)]));
  }
  return value;
};

export const shouldDrop = (event) => {
  if (!event || typeof event !== 'object') return false;
  if (event.event !== ELEMENT_INTERACTION_EVENT_NAME) return false;
  return DROPPED_INTERACTION_EVENT_TYPES.includes(event.eventType);
};

const isLikelyPiiText = (value) =>
  typeof value === 'string' && (value.includes('\n') || value.length > INNERTEXT_MAX_LENGTH);

const stripLikelyPiiText = (event) => {
  if (!event || typeof event !== 'object') return event;
  if (event.event !== ELEMENT_INTERACTION_EVENT_NAME) return event;
  if (event.eventType !== 'click') return event;
  if (!isLikelyPiiText(event.innerText) && !isLikelyPiiText(event.label)) return event;
  const { innerText, label, ...rest } = event;
  return rest;
};

export const sanitize = (event) => {
  if (shouldDrop(event)) return null;
  const stripped = stripLikelyPiiText(event);
  return scrubPii(stripped);
};
